import { dataLayerPush } from "./data-layer-push";

let lastPostingDateFilter = "";

export function trackingOnPostingDateChange(
  newPostingDateFilter: string | undefined
) {
  if (!newPostingDateFilter || lastPostingDateFilter === newPostingDateFilter) {
    return;
  }

  dataLayerPush({
    event: "jobboard_posting_date_used",
    postingDateFilter: newPostingDateFilter,
  });

  lastPostingDateFilter = newPostingDateFilter;
}
